/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/27/2019
 *
 */

import React from 'react';
import loader from '../../../assets/gif/logo1.gif'
import './loader.css'
import Popup from "reactjs-popup";

/** functional component for Loader **/
const Loader = () => {
    return(
        <Popup open={true} contentStyle={{height: '100vh',width: '100vw',padding: '0'}}>
            <div className="loader">
                <img alt="loading" src={loader} />
            </div>
        </Popup>
    );
};

export default Loader;
